import { Editor } from '@tinymce/tinymce-react'
import tinymce from 'tinymce/tinymce'

// Patch getBody() on every TinyMCE editor instance to prevent
// "Cannot read properties of null (reading 'childNodes')" errors.
//
// ROOT CAUSE: TinyMCE's UndoManager registers an 'init' event handler that
// calls editor.getBody().childNodes. When the editor body isn't ready (e.g.
// iframe not fully loaded), getBody() returns null and the access crashes.
//
// WHY PREVIOUS FIX DIDN'T WORK: The old patch wrapped
// EditorManager.createEditor(), but tinymce.init() uses a local/private
// createEditor function inside its closure — it never calls the public
// EditorManager.createEditor(). So the wrapper never ran.
//
// THIS FIX: Listen for the 'SetupEditor' event on the EditorManager, which
// fires in the Editor constructor (before render() and before 'init'). This
// catches every editor created through any code path. We wrap getBody() to
// return an empty div instead of null, so the UndoManager safely creates an
// empty undo level instead of crashing.
tinymce.on('SetupEditor', function(e) {
  var editor = e.editor
  if (editor && typeof editor.getBody === 'function') {
    var originalGetBody = editor.getBody.bind(editor)
    editor.getBody = function() {
      var body = originalGetBody()
      if (body === null || body === undefined) {
        return document.createElement('div')
      }
      return body
    }
  }
})

// ok, black magic time
// tinymce-react runs setContent after init, which we don't need
// because we set the content in the textarea
// so we need the first execution of setContent to do nothing
// or it will override the content from the textarea
Editor.prototype.originalInitEditor = Editor.prototype.initEditor
Editor.prototype.initEditor = function(initEvent, editor) {
  // Guard against editor being destroyed during async initialization.
  // When users navigate away quickly, the editor iframe/body may be destroyed
  // before TinyMCE's async init completes.
  if (!editor || editor.removed) {
    return
  }

  if (this.inline) {
    return Editor.prototype.originalInitEditor.apply(this, [initEvent, editor])
  }
  editor.originalSetContent = editor.setContent
  editor.setContent = function() {
    // First run of this function `editor.setContent` is a noop, the only thing
    // it does is reset setContent back to the original definition so that
    // subsequent runs work normally.
    editor.setContent = editor.originalSetContent
  }
  return Editor.prototype.originalInitEditor.apply(this, [initEvent, editor])
}

// This is a monkey patch to put the initialValue (if present)
// in the textarea, so it renders instantly
Editor.prototype.renderIframe = function() {
  var _this = this
  var value =
    typeof this.props.initialValue === 'string' ? this.props.initialValue : ''
  return React.createElement('textarea', {
    ref: function(elm) {
      return (_this.element = elm)
    },
    style: { visibility: 'hidden' },
    id: this.id,
    defaultValue: value,
  })
}

// Global error handler to suppress TinyMCE errors that occur during editor cleanup.
// These errors happen when the DOM is destroyed before TinyMCE can finish cleanup:
// - "Cannot read properties of null (reading 'childNodes')" - undo manager
// - "Node cannot be null or undefined" - selection bookmark storage
if (typeof window !== 'undefined' && !window._tinymceErrorHandlerInstalled) {
  window.addEventListener(
    'error',
    function(event) {
      if (event.error && event.error.message) {
        var msg = event.error.message
        // Check if this is a known TinyMCE cleanup error
        if (
          (msg.includes(
            "Cannot read properties of null (reading 'childNodes')"
          ) ||
            msg.includes('Node cannot be null or undefined')) &&
          event.filename &&
          (event.filename.includes('tinymce') ||
            event.filename.includes('shared/editor'))
        ) {
          // Prevent the error from being logged to console
          event.preventDefault()
          return
        }
      }
    },
    true
  )
  window._tinymceErrorHandlerInstalled = true
}

module.exports = {
  Editor,
}
